import { BlurredValue } from "@/components/blurred-value";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useConvertedPrice } from "@/hooks/use-converted-price";
import { parseNumericObject } from "@/lib/numeric";
import { cn } from "@/lib/utils";

interface Props {
  readonly open: number;
  readonly close: number;
  readonly className?: string;
  readonly currency?: string;
}

export function OpenClosePrice(props: Props) {
  const textColor =
    props.close > props.open
      ? "text-green-500"
      : props.close < props.open
        ? "text-red-500"
        : "";

  const converted = useConvertedPrice(props.close);
  const priceFormatted = parseNumericObject(converted.price);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <BlurredValue
          isVisible={!isNaN(props.close) && !isNaN(props.open)}
          value={
            <p
              key={priceFormatted}
              className={cn(
                textColor,
                "break-keep tabular-nums",
                props.className,
              )}
              dangerouslySetInnerHTML={{
                __html: `${props.currency ?? converted.meta.symbol ?? "$"}
      ${priceFormatted} `,
              }}
            />
          }
        />
      </PopoverTrigger>
      <PopoverContent className="w-auto bg-primary px-2 py-1 text-sm tabular-nums text-primary-foreground">
        {props.close}
      </PopoverContent>
    </Popover>
  );
}
